<input #imgSelect (change)="fileSelected($event)" accept="image/png,image/gif,image/jpeg,image/apng,image/avif,image/webp" type="file">
<div #canvasBox image>
  @if (data.imageDataUrl == null) {
    <div i18n>
      Mit dem Button rechts unten kann ein Bild<br>geladen werden. Aus diesem kann dann<br>eine Farbe entnommen werden.
    </div>
  } @else {
    <canvas #canvasImage
            (click)="clickCanvas($event)"
            (mouseenter)="canvasMouseEnter($event)"
            (mousemove)="paintLens($event)"
            (mouseout)="canvasMouseOut($event)"
            (wheel)="wheelLens($event)"></canvas>
  }
</div>
<canvas #canvasLens class="lens" height="100"
        width="100"></canvas>
<img #img [src]="data.imageDataUrl" alt="" class="img" id="img">
